/** Layout and surface styles aligned with IntegrationsPage.jsx */

export const pageShellProps = {
  px: 10,
  pt: 10,
  pb: 16,
  maxW: '1200px',
  mx: 'auto',
};

export const contentColumnProps = {
  maxW: '700px',
  w: 'full',
};

export const pageTitleProps = {
  size: 'lg',
  color: '#fafafa',
  fontWeight: '700',
  letterSpacing: '-0.02em',
};

export const pageSubtitleProps = {
  fontSize: 'sm',
  color: 'rgba(255,255,255,0.35)',
  letterSpacing: '0.01em',
};

export const sectionTitleProps = {
  as: 'h2',
  fontSize: 'md',
  fontWeight: '600',
  color: 'rgba(255,255,255,0.88)',
  letterSpacing: '-0.01em',
};

export const listContainerProps = {
  borderRadius: '10px',
  border: '1px solid rgba(255,255,255,0.07)',
  overflow: 'hidden',
};

export function listRowProps(isLast) {
  return {
    px: 5,
    py: 3.5,
    bg: 'transparent',
    transition: 'background 0.12s ease',
    _hover: { bg: 'rgba(255,255,255,0.025)' },
    borderBottom: isLast ? 'none' : '1px solid rgba(255,255,255,0.06)',
  };
}

export const panelBoxProps = {
  p: 4,
  borderRadius: '10px',
  bg: '#171717',
  border: '1px solid rgba(255,255,255,0.10)',
};

export const alertBannerProps = {
  p: 4,
  borderRadius: '10px',
  bg: 'rgba(255,180,80,0.06)',
  border: '1px solid rgba(255,180,80,0.25)',
};

export const inputFieldProps = {
  bg: '#171717',
  border: '1px solid rgba(255,255,255,0.12)',
  borderRadius: 'md',
  color: 'rgba(255,255,255,0.88)',
  _placeholder: { color: 'rgba(255,255,255,0.25)' },
  _hover: { borderColor: 'rgba(255,255,255,0.2)' },
  _focus: { borderColor: 'rgba(255,255,255,0.35)', boxShadow: 'none' },
};

export const formLabelProps = {
  fontSize: 'sm',
  color: 'rgba(255,255,255,0.45)',
  mb: 1.5,
};

export const mutedTextProps = {
  fontSize: 'sm',
  color: 'rgba(255,255,255,0.28)',
};

export const bodyTextProps = {
  fontSize: 'sm',
  color: 'rgba(255,255,255,0.55)',
};

export const primaryButtonProps = {
  size: 'sm',
  bg: '#fafafa',
  color: '#0a0a0a',
  borderRadius: 'full',
  fontWeight: '600',
  fontSize: '13px',
  px: 5,
  h: '36px',
  _hover: { opacity: 0.88 },
  _focus: { boxShadow: 'none', outline: 'none' },
};

export const outlineButtonProps = {
  size: 'sm',
  bg: 'transparent',
  color: 'rgba(255,255,255,0.75)',
  borderRadius: 'full',
  fontWeight: '500',
  fontSize: '13px',
  px: 5,
  h: '36px',
  border: '1px solid rgba(255,255,255,0.15)',
  _hover: {
    borderColor: 'rgba(255,255,255,0.3)',
    color: '#fafafa',
    bg: 'rgba(255,255,255,0.05)',
  },
  _focus: { boxShadow: 'none', outline: 'none' },
};

export const ghostIconButtonProps = {
  variant: 'ghost',
  size: 'sm',
  color: 'rgba(255,255,255,0.45)',
  borderRadius: 'full',
  _hover: { bg: 'rgba(255,255,255,0.06)', color: '#fafafa' },
};

export const dividerProps = {
  borderColor: 'rgba(255,255,255,0.10)',
};

export const linkProps = {
  color: 'rgba(255,255,255,0.55)',
  textDecoration: 'underline',
  textUnderlineOffset: '2px',
  _hover: { color: '#fafafa' },
};

export const rowTitleTextProps = {
  fontSize: 'sm',
  fontWeight: '500',
  color: 'rgba(255,255,255,0.88)',
  letterSpacing: '-0.01em',
};
